import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-image-preview-dialog',
  templateUrl: './image-preview-dialog.component.html',
  styleUrl: './image-preview-dialog.component.scss',
  standalone: false
})
export class ImagePreviewDialogComponent {
  dialogRef = inject<MatDialogRef<ImagePreviewDialogComponent>>(MatDialogRef);
  data = inject<{
    imageUrl: string;
    imageName: string;
  }>(MAT_DIALOG_DATA);

  close(): void {
    this.dialogRef.close();
  }
}
